import React, { useState } from 'react';
import {
    View,
    TextInput,
    TouchableOpacity,
    Image,
    StyleSheet,
    ViewStyle,
    Platform,
} from 'react-native';
import { COLORS } from '../../theme/themeTokens';

interface PasswordInputProps {
    value: string;
    onChangeText: (text: string) => void;
    placeholder?: string;
    editable?: boolean;
    hasError?: boolean;
    style?: ViewStyle;
}

const FONTS = {
    body: Platform.select({
        ios: 'System',
        android: 'sans-serif',
    }),
};

const PasswordInput: React.FC<PasswordInputProps> = ({
    value,
    onChangeText,
    placeholder = 'Password',
    editable = true,
    hasError = false,
    style,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <View
            style={[
                styles.inputWrapper,
                hasError && styles.inputWrapperError,
                style,
            ]}>
            <TextInput
                style={styles.input}
                placeholder={placeholder}
                placeholderTextColor={COLORS.blueSteel}
                value={value}
                onChangeText={onChangeText}
                secureTextEntry={!showPassword}
                autoCapitalize="none"
                autoCorrect={false}
                editable={editable}
            />
            <TouchableOpacity
                style={styles.eyeButton}
                onPress={() => setShowPassword(prev => !prev)}
                disabled={!editable}>
                <Image
                    source={
                        showPassword
                            ? require('../../assets/eye_open_22.png')
                            : require('../../assets/eye_close_22.png')
                    }
                    style={styles.eyeIcon}
                    resizeMode="contain"
                />
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create({
    inputWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: COLORS.borderMuted,
        borderRadius: 8,
        height: 56,
        paddingHorizontal: 16,
        backgroundColor: COLORS.white,
    },
    inputWrapperError: {
        borderColor: COLORS.brandOrange,
        borderWidth: 2,
    },
    input: {
        flex: 1,
        fontFamily: FONTS.body,
        fontSize: 18,
        color: COLORS.deepNavy,
        height: '100%',
    },
    eyeButton: {
        padding: 4,
    },
    eyeIcon: {
        width: 22,
        height: 22,
    },
});

export default PasswordInput;
